import React from 'react';

/** Barre de pagination + résumé extraite de BuildingVehiculesTab.tsx. */

interface VehiculesPaginationBarProps {
  currentPage: number;
  totalPages: number;
  resultsCount: number;
  onPageChange: (page: number) => void;
}

const VehiculesPaginationBar: React.FC<VehiculesPaginationBarProps> = ({
  currentPage,
  totalPages,
  resultsCount,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between pt-2 border-t border-zinc-700">
      <div className="text-sm text-zinc-400">
        Page {currentPage} sur {totalPages} • {resultsCount} résultat
        {resultsCount > 1 ? 's' : ''}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="px-3 py-1 bg-zinc-700 hover:bg-zinc-600 disabled:bg-zinc-800 disabled:text-zinc-600 disabled:cursor-not-allowed text-white rounded text-sm transition-colors"
        >
          Précédent
        </button>
        <div className="flex items-center gap-1">
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum: number;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (currentPage <= 3) {
              pageNum = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = currentPage - 2 + i;
            }
            return (
              <button
                key={pageNum}
                onClick={() => onPageChange(pageNum)}
                className={`px-3 py-1 rounded text-sm ${
                  currentPage === pageNum
                    ? 'bg-blue-600 text-white'
                    : 'bg-zinc-700 hover:bg-zinc-600 text-white'
                }`}
              >
                {pageNum}
              </button>
            );
          })}
        </div>
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="px-3 py-1 bg-zinc-700 hover:bg-zinc-600 disabled:bg-zinc-800 disabled:text-zinc-600 disabled:cursor-not-allowed text-white rounded text-sm transition-colors"
        >
          Suivant
        </button>
      </div>
    </div>
  );
};

export default VehiculesPaginationBar;

